import './style.scss';
import AppCommunitiesSearchResultRow from '../../components/app_communitiesSearchResultRow/AppCommunitiesSearchResultRow';
import { communityStateData } from '../../data/communityStateData';

function AppCommunitiesResultRows() {
	return (
		<div className='section-content section-content-removed-padding'>
			<AppCommunitiesSearchResultRow
				label='Community Type'
				profiles={communityStateData.communities}
			/>
			<AppCommunitiesSearchResultRow
				label='Community Type'
				profiles={communityStateData.communities}
			/>
			<AppCommunitiesSearchResultRow
				label='Community Type'
				profiles={communityStateData.communities}
			/>
		</div>
	)
}

export default AppCommunitiesResultRows
